module.exports = __webpack_public_path__ + "img/pic-04.1351cc1b.png";